

































import dayjs, { parseDateTime } from '@/utils/dayjs';
import { clone } from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class QDatePicker extends Vue {
  @Prop({ type: String, default: '' }) readonly date!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideLabel!: boolean;
  @Prop() readonly inputClass!: string;
  @Prop() readonly label!: string;
  @Prop() readonly minDate!: string;
  @Prop() readonly maxDate!: string;

  menu = false;

  localDate = '';

  get syncedDate() {
    const dateTimeFormat = 'YYYY-MM-DD';
    return parseDateTime(dateTimeFormat, this.date);
  }
  set syncedDate(d) {
    const formattedDate = this.formatDate(d);
    this.$emit('update:date', formattedDate);
  }

  get computedLabel() {
    if (this.hideLabel) {
      return '';
    } else if (this.label?.length) {
      return this.label;
    }
    return (this.required ? '* ' : '') + this.$t('common_word.date_of_birth');
  }

  formatDate(d) {
    const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
    const date = dayjs(d);
    if (!date.isValid()) {
      return '';
    }
    return date.format(dateTimeFormat);
  }

  setLocalDate() {
    this.localDate = clone(this.date);
  }

  setDate(d) {
    const formattedDate = this.formatDate(d);
    this.$emit('update:date', formattedDate);
    this.menu = false;
  }
}
